import React, { useRef, useState, useEffect } from 'react';
import Router from 'next/router';
import Wordcloud from 'wordcloud';

const WordCloud = (props) => {
	const ref = useRef();
	const [height, setHeight] = useState(0);
	const { className, data = [], ...p } = props;
	// const data = [['foo', 5], ['bar', 3]];

	const renderWC = () => {
		const width = ref.current.offsetWidth;
		setHeight(width * 0.4);
	};

	useEffect(() => {
		if (height <= 0) return;
		const width = ref.current.offsetWidth;
		const list = data.filter((x) => x[1] > 30).map((x) => [x[0], x[1] / 12]);
		Wordcloud(ref.current, {
			list,
			fontFamily: '"Noto Sans TC", "Noto Sans CJK TC", "微軟正黑體"',
			color: 'random-dark',
			backgroundColor: '#f4f4f4',
			weightFactor: width / 250,
			gridSize: 22,
			rotateRatio: 0,
		});
	}, [height]);

	useEffect(() => {
		renderWC();
	}, [data]);

	useEffect(() => {
		function resize() {
			renderWC();
		}
		window.addEventListener('resize', resize);
		return () => window.removeEventListener('resize', resize);
	}, []);

	const search = (e) => {
		if (e.target.tagName === 'SPAN') {
			if (globalThis.umami) {
				globalThis.umami.track('home:wordcloud', { action: 'click', label: e.target.innerText });
			}
			Router.push({
				pathname: '/datasets/search',
				query: { s: e.target.innerText },
			});
		}
	};

	return (
		<>
			<div
				ref={ref}
				style={{ height: `${height}px` }}
				{...p}
				className={`wordcloud ${className}`}
				onClick={search}
				onKeyPress={() => {}}
				role="link"
				tabIndex="-1"
			/>
			<style jsx global>
				{`
				.wordcloud {
					position: absolute !important;
				}
				.wordcloud span{
					font-weight: 200 !important;
				}
				.wordcloud span:hover {
					font-weight: 800 !important;
					color: #0f3161 !important;
					cursor: pointer;
				}
				`}
			</style>
		</>
	);
};

export default WordCloud;
